(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ds-featured-product"] && !window.DesignMode) return;
  try {
    
if (!customElements.get('product-modal')) {
    customElements.define('product-modal', class ProductModal extends ModalDialog {
        constructor() {
        super();
    }

    hide() {
        super.hide();
    }

    show(opener) {
        super.show(opener);
        this.showActiveMedia();
    }

    showActiveMedia() {
        this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
            element.classList.remove('active');
            }
        )
        const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
        const activeMediaTemplate = activeMedia.querySelector('template');
        const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
        activeMedia.classList.add('active');
        activeMedia.scrollIntoView();

        const container = this.querySelector('[role="document"]');
        container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

        if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
            activeMedia.loadContent();
        }
    });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-parallax"] && !window.DesignMode) return;
  try {
    
class ParallaxContainer extends HTMLElement {
	constructor(){
		super()
		this.scaling = this.dataset.scale;
		
		this.xDirection = this.dataset.xDirection;
		this.yDirection = this.dataset.yDirection;
		this.translateX = this.xDirection == 'leftToRight' ? this.dataset.translateX : '-' + this.dataset.translateX;
		this.translateY = this.yDirection == 'topToBottom' ? this.dataset.translateY : '-' + this.dataset.translateY;
        this.uniqueId = this.getAttribute('id');
        this.parallaxAnimation;
        this.parallaxOptions = {
            mobileBreakpoint: '(max-width: 749px)',
            desktopBreakpoint: '(min-width: 750px)',
            mobileSelector:  `#${this.uniqueId} .parallax__image--mobile`,
            desktopSelector:  `#${this.uniqueId} .parallax__image--desktop`,
            parallaxContainer: `#${this.uniqueId}.parallax__container`,
            scaling: this.scaling,
            translateY: this.translateY,
            trnaslateX: this.translateX
        }
        this.handleResponsiveSetUp(this.parallaxOptions);
        window.addEventListener('resize', () => {
		    this.handleResponsiveSetUp(this.parallaxOptions);
        });
	}


	handleResponsiveSetUp(options){
        if(window.innerWidth < 750){
            this.setUpParallax(options.mobileBreakpoint, options.mobileSelector, options.parallaxContainer, options.scaling, options.translateY, options.translateX);
        } else {
            this.setUpParallax(options.desktopBreakpoint, options.desktopSelector, options.parallaxContainer, options.scaling, options.translateY, options.translateX);
        }
	}


	setUpParallax(breakpoint, targetSelector, triggerSelector, scale, yScroll, xScroll){

        mm.add(breakpoint, () =>{
			ParallaxContainer.parallaxAnimation = gsap.to(targetSelector, {
				scrollTrigger: {
				trigger: triggerSelector,
				start: '0% 100%',
				end: '100% 0%',
				scrub: true,
				},
				scale: scale,
				y: `${yScroll}%`,
				x: `${xScroll}%`
		})
		})
	
	}
}

customElements.define('parallax-container', ParallaxContainer);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-side-reveal"] && !window.DesignMode) return;
  try {
    
class SideReveal extends HTMLElement {
    constructor(){
        super();
        this.revealImageSelector = this.querySelector('.image-reveal__image');
        this.triggerSelector = this;
        this.revealImage(this.revealImageSelector, this.triggerSelector);
    }

    revealImage(revealImageSelector, trigger){
            gsap.to(revealImageSelector, {
                scrollTrigger: {
                    trigger: trigger,
                    start: '0% 100%',
                    end: '20% 20%',
                    scrub: true
                },
                x: '0%'
            })
    }
}

customElements.define('image-reveal', SideReveal);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
	class LocalizationForm extends HTMLElement {
		constructor() {
			super();
			this.elements = {
				input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
				button: this.querySelector('button'),
				panel: this.querySelector('ul'),
			};
			this.elements.button.addEventListener('click', this.openSelector.bind(this));
			this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
			this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

			this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
		}

		hidePanel() {
			this.elements.button.setAttribute('aria-expanded', 'false');
			this.elements.panel.setAttribute('hidden', true);
		}

		onContainerKeyUp(event) {
			if (event.code.toUpperCase() !== 'ESCAPE') return;

			this.hidePanel();
			this.elements.button.focus();
		}

		onItemClick(event) {
			event.preventDefault();
			const form = this.querySelector('form');
			this.elements.input.value = event.currentTarget.dataset.value;
			if (form) form.submit();
		}

		openSelector() {
			this.elements.button.focus();
			this.elements.panel.toggleAttribute('hidden');
			this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
		}

		closeSelector(event) {
			const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
			if (event.relatedTarget === null || shouldClose) {
				this.hidePanel();
			}
		}
	}

	customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
	class StickyHeader extends HTMLElement {
		constructor() {
			super();
			this.header = document.getElementById('shopify-section-header');
			this.header.classList.add('shopify-section-header-sticky');
			this.announcement = this.getElementsByClassName('announcement')[0];
			this.search = this.getElementsByClassName("header__search")[0];
			this.searchOpen = this.getElementsByClassName('header__search')[0];
			this.searchClose = this.getElementsByClassName("search-modal__close-button")[0];
			this.headerBounds = {};
			this.currentScrollTop = 0;
			this.onScrollHandler = this.onScroll.bind(this);
			// getting header height for use in ds anchor
			document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
		}

		connectedCallback() {
			window.addEventListener('scroll', this.onScrollHandler, false);
			this.createObserver();
		}

		disconnectedCallback() {
			window.removeEventListener('scroll', this.onScrollHandler);
		}

		createObserver() {
			let observer = new IntersectionObserver((entries, observer) => {
				this.headerBounds = entries[0].intersectionRect;
				observer.disconnect();
			});

			observer.observe(this.header);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
			if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom && !this.search.firstElementChild.getAttribute("open")) {
				requestAnimationFrame(this.hide.bind(this));
			} else if (scrollTop <= this.headerBounds.top) {
				requestAnimationFrame(this.reset.bind(this));
			}
			this.currentScrollTop = scrollTop;
		}

		hide() {
			this.header.classList.add('shopify-section-header-sticky');
		}

		reset() {
			this.announcement.classList.remove('small-hide');
		}
	}
	customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"]) return;
  try {
    
	class CartNote extends HTMLElement {
		constructor() {
			super();

			this.addEventListener('change', debounce((event) => {
				const body = JSON.stringify({ note: event.target.value });
				fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
			}, 300))
		}
	}

	customElements.define('cart-note', CartNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	class ProductModal extends ModalDialog {
		constructor() {
			super();

			this.handleMobileGallery();
		}

		handleMobileGallery() {
			if (window.innerWidth <= Shopify.breakpoints.mobile) {
				this.remove();
			}
		}

		hide() {
			super.hide();
		}

		show(opener) {
			super.show(opener);
			this.showActiveMedia();
		}

		showActiveMedia() {
			this.querySelectorAll(`[data-media-id]:not([data-media-id="${this.openedBy.getAttribute("data-media-id")}"])`).forEach((element) => {
				element.classList.remove('active');
				}
			)
			const activeMedia = this.querySelector(`[data-media-id="${this.openedBy.getAttribute("data-media-id")}"]`);
			const activeMediaTemplate = activeMedia.querySelector('template');
			const activeMediaContent = activeMediaTemplate ? activeMediaTemplate.content : null;
			activeMedia.classList.add('active');
			activeMedia.scrollIntoView();

			const container = this.querySelector('[role="document"]');
			container.scrollLeft = (activeMedia.width - container.clientWidth) / 2;

			if (activeMedia.nodeName == 'DEFERRED-MEDIA' && activeMediaContent && activeMediaContent.querySelector('.js-youtube'))
				activeMedia.loadContent();
			}
		}
	customElements.define('product-modal', ProductModal);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-collapsible-content"] && !window.DesignMode) return;
  try {
    
if (window.innerWidth > Shopify.breakpoints.mobile) {
	document.querySelectorAll('.pdp-collapsible-content').forEach(section => {
		section.querySelectorAll('details').forEach(details => {
			let iconCaret = details.querySelector('.icon-caret');
			let summary = details.querySelector('summary');
			details.setAttribute('open', '');
			summary.style.pointerEvents = 'none';
			summary.setAttribute('aria-expanded', 'true');
			iconCaret.classList.add('hidden');
		})
	})
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
	class ProductRecommendations extends HTMLElement {
		constructor() {
			super();

			const handleIntersection = (entries, observer) => {
				if (!entries[0].isIntersecting) return;
				observer.unobserve(this);

				fetch(this.dataset.url)
					.then(response => response.text())
					.then(text => {
						const html = document.createElement('div');
						html.innerHTML = text;
						const recommendations = html.querySelector('product-recommendations');
						if (recommendations && recommendations.innerHTML.trim().length) {
							this.innerHTML = recommendations.innerHTML;
						}
					})
					.catch(e => {
						console.error(e);
					});
			}

			new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
		}
	}

	customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
